import { getOrderConfirmationDetails } from '../../api/Orders/OrderConfirmationApi';
import { IOrderConfirmationResponse } from '../../api/Orders/IOrderConfirmationResponse';
import { AxiosResponse } from 'axios';

export const CLEAR_ORDER_CONFIRMATION_CONTENTS = 'CLEAR_ORDER_CONFIRMATION_CONTENTS';
export type CLEAR_ORDER_CONFIRMATION_CONTENTS = typeof CLEAR_ORDER_CONFIRMATION_CONTENTS;

export const orderConfirmationRequest = (orderId: string, retailerName: string): any => {

  return (dispatch : any) => {
    dispatch({
      type: 'GET_ORDER_CONFIRMATION_REQUEST',
    });

    return getOrderConfirmationDetails(orderId, retailerName)
      .then((response: AxiosResponse<IOrderConfirmationResponse>) => {
        if (response.status === 200) {
          dispatch({
            type: 'GET_ORDER_CONFIRMATION_RESPONSE',
            response: response.data.confirmation,
          });
        } else {
          onError(dispatch, response.data as unknown as string);
        }
      })
      .catch((err: any) => {
        console.log(err);
        onError(dispatch);
      });
  };
};

const onError = (dispatch: any, message: string = null) => dispatch({
  type: 'GET_ORDER_CONFIRMATION_ERROR',
  response: message,
});

export const clearOrderConfirmationContents = () => {
  return {
    type: CLEAR_ORDER_CONFIRMATION_CONTENTS,
  };
};
